import * as THREE from 'three';
import type { Simulation } from '../sim/simulation';

/** What the renderer draws for the current level (built-in course or a loaded map). */
export interface LevelView {
  readonly root: THREE.Object3D;
  /** Linear fog near/far in units. */
  readonly fog: [number, number];
  /** Fog and background colour (default: the built-in sky blue). */
  readonly fogColor?: string;
  /** Camera far plane. */
  readonly far: number;
  /** Per-frame updates from the simulation (moving blocks, glow...). `alpha` interpolates between ticks. */
  update(sim: Simulation, alpha: number): void;
  dispose(): void;
}

/** Free GPU resources of everything under `root`. */
export function disposeTree(root: THREE.Object3D) {
  const textures = new Set<THREE.Texture>();
  const materials = new Set<THREE.Material>();
  root.traverse((o) => {
    const m = o as THREE.Mesh;
    if (m.geometry) m.geometry.dispose();
    const mat = m.material;
    if (mat) for (const x of Array.isArray(mat) ? mat : [mat]) materials.add(x);
  });
  for (const m of materials) {
    for (const v of Object.values(m)) if (v instanceof THREE.Texture) textures.add(v);
    m.dispose();
  }
  for (const t of textures) t.dispose();
  root.removeFromParent();
}
